export type PatientHealthInfo = {
    health_insurance_name: string;
    health_insurance_no: string;
    health_insurance_expiry_date?: string;
};

export type UpdatePatientHealthInfoRequest = {
    Name: string;
    Number: string;
    ExpiryDate: string;
};

export type PatientHasDetails = {
    address: boolean;
    medicare: boolean;
    gender: boolean;
    medicareDetails: PatientMedicare;
    myMedicare: boolean;
    myMedicareRegDate: string;
    isNewPatient: boolean;
    bannedLevel: string;
    outstandingBalance: boolean;
};
export type PatientMedicare = {
    irn: string;
    maskedNumber: string;
    status: MedicareCardStatus;
};
export enum MedicareCardStatus {
    Valid = 'Valid',
    Expired = 'Expired',
    Invalid = 'Invalid',
    Missing = 'Missing',
}

export type PatientDetailsUpdateRequest = {
    address?: PatientUpdateAddress;
    gender?: PatientUpdateGender;
    medicare?: PatientUpdateMedicare;
};

export type PatientUpdateAddress = {
    address: string;
    city: string;
    postcode: string;
};
export type PatientUpdateGender = {
    birthSex: PatientBirthSex;
    genderIdentity?: PatientGenderIdentity;
    preferredPronouns?: PatientPronouns;
};

export enum PatientBirthSex {
    Female = 'F',
    Male = 'M',
    Other = 'O',
}

export enum PatientGenderIdentity {
    Female = 'Female',
    Male = 'Male',
    NonBinary = 'Non-binary',
    GenderDiverse = 'Gender diverse',
    Transgender = 'Transgender',
    DifferentIdentity = 'Different identity',
}

export enum PatientPronouns {
    SheHerHers = 'She/Her/Hers',
    HeHimHis = 'He/Him/His',
    TheyThemTheirs = 'They/Them/Theirs',
}

export type PatientUpdateMedicare = {
    number: string;
    irn: string;
    expiry: Date;
};

export type PatientBasicDetails = {
    surname: string;
    firstname: string;
    dateOfBirth?: string;
    email?: string;
};
